import React from 'react';
import './WhatIsMegaLoto.css';

const WhatIsMegaLoto = () => {
  return (
    <section className="what-is-megaloto">
      <div className="megaloto-content">
        <h2>¿Qué es MEGALOTO?</h2>
        <p>
          MEGALOTO es una plataforma revolucionaria que combina entretenimiento y
          oportunidades de negocio. Participa en sorteos diarios, invita a tus amigos y
          genera ingresos por cada transacción. ¡Todo desde la comodidad de tu hogar!
        </p>
        <a href="https://wa.me/573133956853?text=Estoy%20interesado%20en%20unirme%20al%20grupo%20de%20ventas%20de%20Megaloto,%20me%20das%20más%20informacion,%20por%20favor" className="cta-button">Comienza ahora</a>
      </div>
      <div className="megaloto-image">
        <img src="https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/landings%2Fventas%2F_354efc57-4aa1-48bd-9098-2b437dd72d33.jpeg?alt=media&token=d0881707-7fa0-4673-b4d3-cc132079b96e" alt="MEGALOTO" />
      </div>
    </section>
  );
};

export default WhatIsMegaLoto;
